var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.39966 15.8008H12.5997",
    stroke: "#1E1F26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.28111 11.9708C2.9987 10.133 2.85749 9.21411 3.20494 8.39951C3.55238 7.5849 4.32323 7.02755 5.86492 5.91285L7.0168 5.08C8.93464 3.69334 9.89353 3 11 3C12.1065 3 13.0654 3.69334 14.9832 5.08L16.1351 5.91285C17.6768 7.02755 18.4476 7.5849 18.7951 8.39951C19.1425 9.21411 19.0013 10.133 18.7189 11.9708L18.4781 13.5379C18.0777 16.1431 17.8775 17.4458 16.9432 18.2229C16.0089 19 14.643 19 11.9111 19H10.089C7.35707 19 5.99113 19 5.0568 18.2229C4.12247 17.4458 3.9223 16.1431 3.52194 13.5379L3.28111 11.9708Z",
    stroke: "#1E1F26",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.09ebf6f673d8565d6d4cbd0ec9228195.svg";
export { ForwardRef as ReactComponent };